import { ProductGroupEntity } from '@/entities/product-group.entity';
import { useMarketplaceApi } from '@/context/marketplace.context';
import { useSelectionGroupAction } from '@/components/action-buttons/use-selection-group-action';
import { createSessionSelectionSyncAdapter } from '@/components/group-tables/selection-sync-adapter';

type UseSelectionProductsActionParams = {
    accessToken: string;
    selectionSessionId: string;
    hasPickedProducts: boolean;
    products: ProductGroupEntity[];
    maxSelectedItems: number | null;
    setPickedProducts?: (val: string[]) => void;
};

type UseSelectionProductsActionReturn = {
    onAllPickedProducts: () => Promise<void>;
};

export const useSelectionProductsAction = ({
    accessToken,
    selectionSessionId,
    hasPickedProducts,
    products,
    maxSelectedItems,
    setPickedProducts,
}: UseSelectionProductsActionParams): UseSelectionProductsActionReturn => {
    const { productsApi } = useMarketplaceApi();
    const selectionSync = createSessionSelectionSyncAdapter({
        sessionId: selectionSessionId,
        setPickedIds: setPickedProducts,
        clearSelection: () =>
            productsApi.clearProductSelectionSession(selectionSessionId, {
                authToken: accessToken,
            }),
        setSelection: (ids) =>
            productsApi.setProductSelectionSession(selectionSessionId, ids, {
                authToken: accessToken,
            }),
    });

    const { onAllPickedItems: onAllPickedProducts } = useSelectionGroupAction({
        hasPickedItems: hasPickedProducts,
        allItemIds: products.map((product) => product.id),
        maxSelectedItems,
        setPickedItems: selectionSync.setPickedIds,
        clearSelection: selectionSync.clearSelection,
        setSelection: selectionSync.setSelection,
        clearSelectionErrorMessage: 'Не удалось снять выделение',
        setSelectionErrorMessage: 'Не удалось выделить группы',
    });

    return {
        onAllPickedProducts,
    };
};
